<template>
  <BaseBadge
    :custom-class="'lg:text-base font-normal'"
    :custom-style="customStyle"
    :text="displayText"
    :uppercase="false"
    border-radius="rounded-full"
    padding="px-3 py-1"
    size="md"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  type StatusType = 'active' | 'pending' | 'disabled' | 'deleted' | string;
  const props = defineProps<{
    status: StatusType;
  }>();

  // Extract constants for status text and style mappings
  const STATUS_TEXT_MAP: Record<string, string> = {
    active: 'Active',
    pending: 'Invite sent',
    disabled: 'Disabled',
    deleted: 'Deleted'
  };

  // Common styles for reuse
  const COMMON_INACTIVE_STYLE = {
    color: '#AFB9C6',
    backgroundColor: 'rgba(185, 192, 202, 0.1)'
  };

  const STATUS_STYLE_MAP: Record<string, Record<string, string>> = {
    active: { backgroundColor: '#2C361B', color: '#AFE614' },
    pending: COMMON_INACTIVE_STYLE,
    disabled: { backgroundColor: '#532B2C', color: '#F57974' },
    deleted: COMMON_INACTIVE_STYLE
  };

  const DEFAULT_STYLE = {
    color: 'var(--color-dark1)',
    backgroundColor: 'white'
  };

  // Use the mapping objects instead of switch statements
  const normalizedStatus = computed(() => props.status.toLowerCase());

  const displayText = computed(
    () => STATUS_TEXT_MAP[normalizedStatus.value] || props.status
  );

  const customStyle = computed(
    () => STATUS_STYLE_MAP[normalizedStatus.value] || DEFAULT_STYLE
  );
</script>
